import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AutomationService } from '../services/automation.service'
import { User } from '../models/user';
import * as Highcharts from 'highcharts';
import { first } from 'rxjs';
import { error } from 'jquery';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { backgroundClip } from 'html2canvas/dist/types/css/property-descriptors/background-clip';
import { AppiumLogParserService } from '../services/appium-logs-generator.service';
import * as XLSX from 'xlsx';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class ReportComponent implements OnInit, OnDestroy {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";
  deviceList: any = []
  finalLogsdata: any = []
  date2: any
  date1: any
  currentUser: User
  // logInterval: any;
  statusList: any = ['TIMED OUT', 'COMPLETED', 'RUNNING', 'STOPPED']
  fullLogList: any = [];
  fromDate: any;
  toDate: any;
  currentDate: string
  filterDevice: any = 'All';
  filterStatus: any = 'All'
  completed: any;
  running: any;
  stopped: any;
  timedOut: any;
  activeLogData: any = []
  loglist: any[] = [];
  prevCompleted = 0;
  prevRunning = 0;
  prevTimedOut = 0;
  prevStopped = 0;
  appiumLogs: any;
  isAppiumLogs: boolean = false;
  currentPage: number = 1; // Current page number (1-based index)
  itemsPerPage: number = 25; // Number of rows per page
  totalPages: number = 0; // Total number of pages
  paginatedLogs: any[] = [];

  updatePagination() {
    // Calculate the total number of pages based on the finalLogsdata length
    this.totalPages = Math.ceil(this.finalLogsdata.length / this.itemsPerPage);

    // Calculate the slice of logs to display on the current page
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedLogs = this.finalLogsdata.slice(start, end);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  closeLogs(): void {
    this.isAppiumLogs = false; // Hide the table when the close button is clicked
  }
  constructor(
    private dialog: MatDialog,
    private automationService: AutomationService,
    private loginService: LoginService,
    private appiumLogService: AppiumLogParserService
  ) {
    const today = new Date();
    this.currentDate = today.toISOString().substring(0, 10);
    //Currentuser Details 
    this.loginService.currentUser.subscribe(x => this.currentUser = x)
  }


  ngOnDestroy(): void {
    // clearInterval(this.logInterval);
  }

  ngOnInit(): void {

    const today = new Date();
    this.toDate = this.currentDate;
    let prevMonth = new Date(today.getTime() - 180 * 24 * 60 * 60 * 1000);
    this.fromDate = prevMonth.toISOString().substring(0, 10);
    this.getAutomationLogs();
    // this.startLogInterval();
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  handleDateChange() {


    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      // this.toDate = this.fromDate;
      this.msg = "Please select a valid date";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please select a valid date');
    } else {
      this.doFilter(); // Call filtering if dates are valid
    }
  }


  getAutomationLogs() {

    // return this.AutomationService.getAutomationLogs(this.currentUser.email).subscribe((response:any)=>{
    //   console.warn(response)

    //   this.fullLogList=response.data.logsData
    //   this.doFilter();
    //   this.deviceList=[...new Set(this.fullLogList.map(i => i.deviceName))].sort()
    //   this.statusList = [...new Set(this.fullLogList.map(i => i.status))].sort()
    // })
    this.automationService.getAutomationLogs(this.currentUser.email).pipe(first()).subscribe((response: any) => {
      this.fullLogList = response.logsData;

      this.doFilter(); // Make sure this function is correctly implemented
      this.finalLogsdata = this.fullLogList; // Set the finalLogsdata to the full list after processing

      this.deviceList = [...new Set(this.fullLogList.map(i => i.deviceName))].sort();
      this.statusList = [...new Set(this.fullLogList.map(i => i.status))].sort();

    });

  }

  // startLogInterval() {
  //   this.logInterval = setInterval(() => {
  //     this.getAutomationLogs();
  //   }, 7000)
  // }

  doFilter() {
    const from = new Date(this.fromDate).getTime();
    const to = new Date(this.toDate).getTime();

    this.finalLogsdata = this.fullLogList.filter(i => {
      const logTime = new Date(i.startTime).getTime();
      return logTime >= from && logTime <= to;
    });

    if (this.filterStatus !== 'All') {
      this.finalLogsdata = this.finalLogsdata.filter(i => i.status === this.filterStatus);
    }
    if (this.filterDevice !== 'All') {
      this.finalLogsdata = this.finalLogsdata.filter(i => i.deviceName === this.filterDevice);
    }

    // Reset to first page when filtering
    this.currentPage = 1;
    this.updatePagination();

    // Count statuses
    this.completed = this.finalLogsdata.filter(i => i.status === "COMPLETED").length;
    this.stopped = this.finalLogsdata.filter(i => i.status === "STOPPED").length;
    this.running = this.finalLogsdata.filter(i => i.status === "RUNNING").length;
    this.timedOut = this.finalLogsdata.filter(i => i.status === "TIMED OUT").length;

    if (this.prevCompleted !== this.completed || this.prevRunning !== this.running ||
      this.prevTimedOut !== this.timedOut || this.prevStopped !== this.stopped) {
      this.createChart();
      this.prevCompleted = this.completed;
      this.prevRunning = this.running;
      this.prevTimedOut = this.timedOut;
      this.prevStopped = this.stopped;
    }
  }


  setDateRange(days: number) {
    const today = new Date();
    this.toDate = today.toISOString().substring(0, 10);

    const from = new Date();
    from.setDate(today.getDate() - days);
    this.fromDate = from.toISOString().substring(0, 10);

    this.doFilter(); // Re-filter after setting the date range
    // Optionally hide quick filters after selection
  }




  //Duration
  floor(data) {
    return Math.floor(data / 60);
  }

  downloadLogFile(logPath: any, appiumUrl: any) {
    // Check if logs are already loaded
    if (this.appiumLogs && this.appiumLogs.length > 0) {
      // If logs are already loaded, download them directly
      this.downloadLogsAsExcel(this.appiumLogs);
    } else {
      // If logs are not loaded yet, fetch them first
      this.automationService.downloadLogFile(logPath, appiumUrl)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            // Parse the response into log entries
            const logEntries = this.appiumLogService.parseLogData(response);

            // Set the logs
            this.appiumLogs = logEntries;

            // Download as Excel
            this.downloadLogsAsExcel(this.appiumLogs);
          },
          error: (error) => {
            console.error('Error downloading log file:', error);
            this.msg = "Failed to download log file";
            this.openAlertMod(this.alertTemplate, this.msg);
          }
        });
    }
  }

  viewLogFile(logPath: string, appiumUrl: string) {
    // Toggle the visibility of Appium logs
    this.isAppiumLogs = !this.isAppiumLogs;



    // Download the log file using the automation service
    this.automationService.downloadLogFile(logPath, appiumUrl)
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          // Parse the response into log entries
          const logEntries = this.appiumLogService.parseLogData(response);

          // Update component property to display logs in the table
          this.appiumLogs = logEntries;

        },
        error: (error) => {
          console.error('Error downloading log file:', error);
          // Reset logs and show error state
          this.appiumLogs = [];
        }
      });
  }

  // New method to download logs as Excel
  private downloadLogsAsExcel(logEntries: any[]) {
    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(logEntries);

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Appium Logs');

    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = `appium_logs_${new Date().toISOString().replace(/:/g, '-')}.xlsx`;

    // Create a link element and trigger download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }


  deleteLog(log: any) {
    let msg = confirm('This record will be deleted permanently...\nAre you sure to delete?')
    if (msg) {
      this.automationService.deleteLog(log.id, log.path).pipe(first()).subscribe((response: any) => {
        this.getAutomationLogs();
        this.msg = "record successfully deleted";
        this.openAlertMod(this.alertTemplate, this.msg);

        // alert('record successfully deleted')
      });
    }
  }

  showDetailedLog(data) {

    // Call getLogContent from AutomationService to fetch the log as a Blob
    this.automationService.getLogContent(data.logPath).subscribe({
      next: (response: Blob) => {
        // Convert the Blob to text
        const reader = new FileReader();
        reader.onload = (e) => {
          const text = e.target?.result as string; // Get the text content from the Blob


          // Hide the log table and show the detailed log section
          document.getElementById("logTable").style.display = "none";
          document.getElementById("detailLog").style.display = "flex";

          // Store the active log data (optional)
          this.activeLogData = data;

          // Process and format the log content into a table
          this.formatLog(text);
        };

        // Read the Blob as text
        reader.readAsText(response);
      },
      error: (error) => {
        console.error("Error fetching log content", error);
        // Handle errors (e.g., show an error message to the user)
      },
      complete: () => {
        // Optionally log when the process is completed
      }
    });
  }

  // show hinden Logtables
  showLogTable() {
    document.getElementById("logTable").style.display = "block"
    document.getElementById("detailLog").style.display = "none";
  }

  timediff(date1, date2) {
    return (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
  }

  formatLog(data: string) {

    // Split the log into list based on specific criteria (timestamps)
    const list = data.replace(/\n\n/g, '\n').split(/\s+(?=[0-9]{4}-[0-9]{2}-[0-9]{2})/);

    // Start constructing the HTML table to display the logs
    let tableContent = `<table class="table table-bordered" style="width:100%; border-collapse: collapse;">
                          <thead>
                            <tr>
                              <th>Timestamp</th>
                              <th>Request/Response</th>
                              <th>Details</th>
                              <th>Duration</th>
                            </tr>
                          </thead>
                          <tbody>`;

    // Iterate over the list to format each log entry into table rows
    for (let i = 0; i < list.length; i++) {
      const w = list[i].split("-->");

      let row = `<tr>`;
      row += `<td>${w[0].trim()}</td>`; // Timestamp (first part)

      // Check if it's a "Request" log
      if (w.length > 2 && w[1].includes("Request")) {
        let requestDetails = w[2].trim(); // Request URL or method
        const d = w[3].trim().split("/");

        switch (d[d.length - 1]) {
          case "session": {
            requestDetails = `<b>Start Session..</b> ${w[4]}`;
            break;
          }
          case "elements":
          case "element":
          case "click": {
            const j = JSON.parse(w[4]);
            requestDetails = `<b>${d[d.length - 1]}</b> ${j.using} = ${j.value}`;
            break;
          }
          default: {
            requestDetails = `${w[3]} ${w.length > 4 ? w[4] : ""}`;
            break;
          }
        }

        row += `<td>Request</td>`;
        row += `<td>${requestDetails}</td>`;

        // Check for the corresponding "Response" and calculate duration if present
        if (list[i + 1] && list[i + 1].split("-->")[1]?.includes("Response")) {
          i++; // Skip to the next entry (Response)
          const res = list[i].split("-->");
          const duration = this.timediff(w[0], res[0]); // Time difference between request and response
          row += `<td>${res[2]} ${res[3]}</td>`; // Response details
          row += `<td>${duration} ms</td>`; // Duration
        } else {
          row += `<td></td>`; // Empty if no response found
          row += `<td></td>`; // No duration if no response
        }
      } else {
        // If the log is not a request, add empty values for Request/Response and Duration
        row += `<td></td>`;
        row += `<td></td>`;
        row += `<td>${this.timediff(w[0], list[i + 1]?.split("-->")[0] || '')}</td>`; // Time difference
      }

      row += `</tr>`;
      tableContent += row;
    }

    // Close the table after processing all logs
    tableContent += `</tbody></table>`;

    // Insert the generated table HTML into the DOM for display
    const logDetailSection = document.getElementById("detailLog");
    if (logDetailSection) {
      logDetailSection.innerHTML = tableContent; // Insert table content into the detail section
    }

    // Optionally, log the final HTML content for debugging
    return tableContent; // Return the generated table content
  }


  createChart() {
    let parent = document.getElementById("piechart");

    let opts: any = {
      chart: {
        renderTo: parent,
        height: 200,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        backgroundColor: null,
      },
      colors: ['#297ee2', '#0e8a09', '#917210', 'red'],
      legend: {
        align: 'center',  // Center the legend horizontally
        verticalAlign: 'bottom', // Move legend to the bottom
        layout: 'horizontal', // Set layout to horizontal
        x: 0,
        y: 20, // Adjust vertical position of legend if needed
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: null,
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [{
        name: 'Total',
        colorByPoint: true,
        data: [{
          name: 'Running',
          y: this.running,
        }, {
          name: 'Completed',
          y: this.completed,
        }, {
          name: 'Timed-out',
          y: this.timedOut,
        }, {
          name: 'Stopped',
          y: this.stopped,
        }]
      }]
    };
    new Highcharts.Chart(opts);
  }

















  // need to check this code -->
  showResDiv(data) {
    document.getElementById('res' + data).style.display = "flex";
    document.getElementById('expand' + data).style.display = "none";
    document.getElementById('collapse' + data).style.display = "block";
  }

  // need to check this code -->
  hideResDiv(data) {
    document.getElementById('res' + data).style.display = "none";
    document.getElementById('expand' + data).style.display = "block";
    document.getElementById('collapse' + data).style.display = "none";
  }
}



